module.exports = __webpack_public_path__ + "static/media/background4.6614f9f0.jpg";